<mat-radio-group
  [(ngModel)]="userCollection.collection_rights_id"
  [disabled]="disabled"
  (ngModelChange)="onChangedCollectionRights(userCollection)"
>
  @for (rightType of collectionRightTypes; track $index) {
    <mat-radio-button [value]="rightType.artifact_id">
      {{ rightType.artifact_name.toUpperCase() }}
    </mat-radio-button>
  }
</mat-radio-group>
